import { render } from "./cafeItemDetailsDrawer.vue?vue&type=template&id=9313e5e0&scoped=true"
import script from "./cafeItemDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./cafeItemDetailsDrawer.vue?vue&type=script&lang=js"

import "./cafeItemDetailsDrawer.vue?vue&type=style&index=0&id=9313e5e0&lang=scss&scoped=true"
import "./cafeItemDetailsDrawer.vue?vue&type=style&index=1&id=9313e5e0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9313e5e0"]])

export default __exports__